import '@sportabel/fontawesome/css/fontawesome.css'
import '@sportabel/fontawesome/css/light.css'
import '@sportabel/fontawesome/css/solid.css'

import Vue from 'vue'
import './plugins/axios'
import './plugins/vuetify'
import './plugins/vuetifyConfirm'
import './plugins/json2csv'
import App from './App.vue'
import router from './router'
import store from './store'
import './mixin'
import axios from "axios";

Vue.config.productionTip = false

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status === 401) {
    store.dispatch('logout')
    router.push('/')
  }
  return Promise.reject(error)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
